export default __webpack_public_path__ + "static/media/Belt of the Defiant.f6c77169.jpg";